import { render, staticRenderFns } from "./ScriptSentence.vue?vue&type=template&id=7c9127b0&"
import script from "./ScriptSentence.vue?vue&type=script&lang=ts&"
export * from "./ScriptSentence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports